// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Textarea-module--inputWrapper--SxQia","input":"Textarea-module--input--yDJrU","black":"Textarea-module--black--2HmLg"};